import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "view_simple",
  "use": "view_simple-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"view_simple\"><g fill-rule=\"evenodd\"><path d=\"M2 5h16v1H2z\" /><path d=\"M2 8h16v1H2z\" opacity=\".9\" /><path d=\"M2 11h16v1H2z\" opacity=\".8\" /><path d=\"M2 14h16v1H2z\" opacity=\".7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol